export default __webpack_public_path__ + "static/media/xiugaimima.295e896a.png";